// English strings for the documents stream: visitor document validity and readiness (PB-05-07),
// contractor evidence expiry alerts (PB-09-08) and configurable document requirements (PB-07-09).
export const enDocuments = {
  // ------------------------------------------------------------ visitor pass (PB-05-07)
  'prereg.doc.validUntil': 'Valid until {date}.',
  'prereg.doc.validUntilField': 'Valid until (as printed on the document)',
  'prereg.doc.validUntilHint': 'Your visit continues until {through}; the document must be valid until at least that day.',
  'prereg.doc.expiresBeforeVisit': 'This document is valid until {validUntil}, but your visit continues until {through}. Please upload a document that is valid until at least {through}.',
  // ------------------------------------------------------------ visit detail, host (PB-05-07)
  'prereg.host.expired': '{document}: valid until {validUntil}, the visit continues until {through}.',
  'prereg.host.nextAction': 'The earlier review stays on record. The visitor can upload a newer document from their visitor pass, or reception can review one on arrival.',
  'prereg.host.noticed': 'You were notified: {status}.',
  'prereg.host.notice.queued': 'sending',
  'prereg.host.notice.accepted': 'sent',
  'prereg.host.notice.failed': 'not sent yet (will retry)',
  'prereg.host.notice.blocked': 'not sent (no template in your language)',
  'prereg.host.notice.none': 'not sent (no email address on record)',
  // ------------------------------------------------------------ policy editor (PD-450)
  'vpolicy.pr.docValidUntil': 'Ask for the validity date',
  // ------------------------------------------------------------ identity review (PD-450, PD-453)
  'ver.doc.validUntil': 'valid until {date}',
  'ver.doc.validUntilMissing': 'no validity date recorded',
  'ver.doc.validUntilField': 'Valid until',
  'ver.doc.validSource.visitor': 'stated by the visitor',
  'ver.doc.validSource.reviewer': 'confirmed by a reviewer',
  'ver.doc.correctValidity': 'Correct validity',
  // ------------------------------------------------------------ communications
  'comms.key.host_readiness_changed': 'Document no longer covers the visit (to host)',
  'comms.key.evidence_expiring': 'Contractor evidence expiring',
  // ------------------------------------------------------------ contractor evidence alerts (PB-09-08)
  'doc.mail.header': 'Contractor compliance',
  'doc.mail.role.owner_host': "the company's accountable sponsor",
  'doc.mail.role.coordinator': 'a contractor administrator and this company has no sponsor',
  'ctr.ui.alertRaised': 'Raised {date}',
  'ctr.ui.alertNotice': '{name} ({role}): {status}',
  'ctr.ui.alertRole.owner_host': 'sponsor',
  'ctr.ui.alertRole.coordinator': 'contractor administrator',
  'ctr.ui.noticeStatus.queued': 'sending',
  'ctr.ui.noticeStatus.accepted': 'sent',
  'ctr.ui.noticeStatus.failed': 'not sent yet',
  'ctr.ui.noticeStatus.blocked': 'not sent',
  // ------------------------------------------------------------ document requirements (PB-07-09)
  'ctr.col.acceptedIssuers': 'Accepted issuers',
  'ctr.col.reviewers': 'Reviewers',
  'ctr.ui.issuersHint': 'One issuer per line. Leave empty to accept any issuer.',
  'ctr.ui.reviewerExperiences': 'Roles',
  'ctr.ui.reviewerExperiencesHint': 'Role codes, separated by commas (for example permit). Leave empty for anyone who may decide contractor evidence.',
  'ctr.ui.reviewerGroups': 'Approver groups',
  'ctr.ui.reviewerGroupsHint': 'Approver group keys, separated by commas. Leave empty for anyone who may decide contractor evidence.',
  'ctr.v.issuerNotAccepted': 'This issuer is not on the accepted list for this document type.',
  'ctr.v.unknownExperience': 'Use the code of a staff role.',
  'ctr.v.duplicateIssuer': 'This issuer is already listed.',
  'ctr.v.unknownGroup': 'No active approver group has this key.',
  'ctr.api.reviewerNotAssigned': 'You are not assigned to review this document type.',
} as const;
